import React from 'react'

const Navbar = () => {
  return (
    <nav className="navbar bg-light justify-content-center">
      <a className="navbar-brand" href="/">
        React Bands App
      </a>
    </nav>
  )
}

export default Navbar
